import BarbaView from 'abstractions/BarbaView'
import Buy from 'components/Buy'

export default new BarbaView('buy', {
  afterEnter: function ({ next }) {
    this.refs.buy = new Buy()
    this.refs.buy.hydrate(next.container.querySelector('form.buy'))
  }
})
